/**
 * Creates an Confirmation Model with two params
 */
export class ConfirmationModel {
	title: string;
	message: string;

	constructor(title: string, message: string) {
		this.title = title;
		this.message = message;
	}
}